import Http from "../../http/client";

export default async (payload) => {
  const response = await Http.post('admin/specialdays', payload);
  return response.data;
}
